import { render, staticRenderFns } from "./ResourceListContainer.vue?vue&type=template&id=2a768810&scoped=true"
import script from "./ResourceListContainer.vue?vue&type=script&lang=js"
export * from "./ResourceListContainer.vue?vue&type=script&lang=js"
import style0 from "./ResourceListContainer.vue?vue&type=style&index=0&id=2a768810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a768810",
  null
  
)

export default component.exports